import { createGlobalStyle } from 'styled-components';

import { countryListMobileStyle } from '../components/input-phone/input-phone';

export const GlobalStyle = createGlobalStyle`
  :root {
    --font-work-sans: 'Work Sans', sans-serif;
  }
  ${countryListMobileStyle}
`;
